import React, { Component } from "react";
import { FontAwesomeIcon }            from '@fortawesome/react-fontawesome'
import { Button, Modal, FormControl } from "react-bootstrap";
import { invokeSetCreateReminder }    from "../../utils/AwsInvoke";
import { Colors }                     from "../../utils/Colors";
import LoaderButton                   from "../../components/LoaderButton";
import DropdownTextTrainer            from "../../components/form/DropdownTextTrainer";
import "../../css/modal/ModalTrainerTextMsg.css";
import { invokeSendTrainerTextMessage } from "../../utils/AwsInvoke";

export default class ModalTrainerTextMsg extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: "",
            error: ""
        };
    }

    componentDidMount () {
        console.log("component mounted");
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            title: "",
            error: ""
        });
    }

    handleTitleChange (event) {
        this.setState({
            title: event.target.value
        });
    }

    handleMessageChange = (event) => {
        this.setState({ message: event.target.value});
    }

    handleSubmit = async event => {
        var trainer_name  = this.props.trainerName;
        var trainer_phone = this.props.trainerPhone;
        var trainer_id    = this.props.trainerId;
        var athlete_id    = this.props.athleteId
        var message       = this.state.message;

        if(message == "" || message == undefined) {
            alert("you need to enter a message")
            return false;
        }
        this.setState({
            isLoading: true
        })

        //// Submit text msg /////
        if(message != "" && message != undefined) {
            console.log("Submit msg - trainer_phone: " + trainer_phone);

            const results = await invokeSendTrainerTextMessage(trainer_name, trainer_id, athlete_id, message, trainer_phone);
            console.log(">>>>>>>>>>> results: " + results);
            for(var key in results) {
                console.log("key: " + key);
                console.log("results: " + results[key]);
            }
            console.log("----------------------");
            var result = JSON.parse(results["body"]);

            if(result.status) {
                console.log("GO AND HIDE!");
                this.props.onHide("The text message was sent to " + this.props.athleteName + "."); // Close Modal //
            }

            this.setState({
                isLoading: false
            })
        } else {
            this.setState({
                error: "Looks like there's an error with your message. Try sending it again.",
                isLoading: false
            })
        }
    }

    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13) {
             this.props.onHide();
             this.handleSubmit();
        }
    }

    cancel () {
        this.props.onHide();
    }

    sendTrainerText = async (event) => {
        var curr_phone = this.props.trainerPhone;
        var full_name  = this.props.clientName; //this.state.first_name + " " + this.state.last_name;
        console.log("full_name: " + full_name);
        //var test = await invokeSendTrainerTextMessage(full_name, curr_phone);
    }

    dropdownSelection = (message) => {

        this.setState({
            message: message
        })
    }

    render() {
        var message = this.state.message;
        var error = this.state.error;
        return (
            <Modal
                show={this.props.showModalTrainerTextMsg}
                onHide={this.props.onHide}
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <FontAwesomeIcon icon="sms"
                                         className="modalBasicsTitleIcon"
                                         style={{ position:"relative", color: Colors.primary_color}}/>
                        <span className="modalBasicsTitle">
                             Text Trainer: <b>{this.props.trainerName}</b>
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="modalBasicsBody">
                          Send a message to your trainer about:<br/><br/>
                            Athlete: <b>{this.props.athleteName}</b><br/>
                            Program: <b>{this.props.programName}</b><br/>
                            Last login: <b>{this.props.athleteLastLogin}</b><br/>
                          <br/>
                          <DropdownTextTrainer
                                selection   = {this.dropdownSelection}
                                athleteName = {this.props.athleteName}
                                programName = {this.props.programName}
                          />
                          <br/><br/>
                          {/*<div>
                              <div className="modalFormLabelBody">Title</div>
                              <FormControl
                                  onChange     = {this.handleTitleChange.bind(this)}
                                  defaultValue = {""}
                                  className    = "input-lg formModalExerciseField"
                                  type         = "text"
                                  onKeyPress   = {this.handleKeyPress}
                              />
                          </div>
                          <br/>*/ }

                          { /*}<div>
                              <div className="modalFormLabelBody">Assign To</div>
                              <FormControl
                                  onChange     = {this.handleTitleChange.bind(this)}
                                  defaultValue = {""}
                                  className    = "input-lg formModalExerciseField"
                                  type         = "text"
                                  onKeyPress   = {this.handleKeyPress}
                              />
                              </div>
                              <br/> */ }
                          <div>
                              <div className="modalFormLabelBody">Message</div>
                              <textarea placeholder  = {""}
                                        style        = {{paddingLeft: "15px",paddingTop:"10px", height: 150, width:"100%", fontSize:"20px", border: "2px solid #ccc"}}
                                        value        = {this.state.message}
                                        className    = "trainerSendTextMessage"
                                        onChange     = {this.handleMessageChange}
                                     />
                          </div>
                          <span style={{paddingTop:15, fontSize: 16, color: "red"}}>{error}</span>
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <span onClick = { () => this.cancel()} >
                        <LoaderButton
                          height    = {38}
                          width     = {150}
                          btncolor  = { Colors.cancel_button_bg }
                          type      = "button"
                          text      = "Cancel"
                          className="modalBasicsBtnClose"
                        />
                    </span>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    <span onClick = { () => this.handleSubmit()}>
                        <LoaderButton
                            //disabled={!this.validateForm()}
                            isLoading={this.state.isLoading}
                            height    = {38}
                            width     = {150}
                            btncolor  = { Colors.ok_button_bg }
                            text      = "Submit"
                            type      = "submit"
                            loadingText="Saving …"
                        />
                   </span>
                </Modal.Footer>

              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalTrainerTextMsg.js